import React from 'react';
import { AppCartContextInterface } from '../../types/AppCartTypes';

// Create a context with no initial values.
export const AppCartContext = React.createContext<AppCartContextInterface | null>(null);

export default AppCartContext;
